module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td>Минимальное значение высоты <span class=\"required\"></span></td>\n			<td><control type=\"text\" target=\"item.minimum\"/></td>\n		</tr>\n		<tr>\n			<td>Максимальное значение высоты <span class=\"required\"></span></td>\n			<td><control type=\"text\" target=\"item.maximum\"/></td>\n		</tr>\n		<tr>\n			<td>Единица измерения высоты <span class=\"required\"></span></td>\n			<td><control type=\"text\" target=\"item.units\"/></td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}